/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

export const getSelectedIds = state => state.internalStore.selectedIds;
export const getSelectedTaskIds = state => _.get(getSelectedIds(state), 'tasks');
export const getSelectedPropertyIds = state => _.get(getSelectedIds(state), 'properties');
export const getSelectedPersonIds = state => _.get(getSelectedIds(state), 'people');
